import React, { lazy, Suspense } from 'react'

export function createLazyComponentWithSuspense<T>(
	factory: () => Promise<{ default: React.ComponentType<T> }>,
	fallback: (props: T) => React.ReactElement | null = () => null,
	strictMode?: boolean,
) {
	const LazyComponent = lazy(factory)
	return function ComponentWithSuspense(props: T) {
		//@ts-expect-error todo if you see this please remove this comment and fix the type error
		const lazyComponent = <LazyComponent {...props} />

		return (
			<Suspense fallback={fallback(props)}>
				{strictMode || strictMode === undefined ? <React.StrictMode>{lazyComponent}</React.StrictMode> : lazyComponent}
			</Suspense>
		)
	}
}
